module.exports = __webpack_public_path__ + "static/img/边9.d5ad6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边9.png
// module id = wugr
// module chunks = 2